"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _eq = _interopRequireDefault(require("lodash/fp/eq"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _curryRight = _interopRequireDefault(require("lodash/fp/curryRight"));
var _FormGroupContext = require("./FormGroupContext");
var _createId = require("./createId");
var _Form = require("../Form");
var _utils = require("../Form/utils");
var _excluded = ["field", "name", "required", "label", "isHorizontal", "hasError", "hideAsterisk", "children", "className", "customizeLayout", "withoutLayout"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var renderGroupItems = function renderGroupItems(_ref) {
  var children = _ref.children,
    label = _ref.label,
    field = _ref.field;
  return label && field ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label, field) : children;
};
var FormGroup = function FormGroup(_ref2, ref) {
  var field = _ref2.field,
    name = _ref2.name,
    required = _ref2.required,
    label = _ref2.label,
    isHorizontal = _ref2.isHorizontal,
    hasError = _ref2.hasError,
    hideAsterisk = _ref2.hideAsterisk,
    children = _ref2.children,
    className = _ref2.className,
    customizeLayout = _ref2.customizeLayout,
    withoutLayout = _ref2.withoutLayout,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    labelText = _useState2[0],
    setLabelText = _useState2[1];
  var staticFields = (0, _react.useMemo)(function () {
    return {
      name: name,
      inputId: (0, _createId.inputId)(name),
      errorId: (0, _createId.errorId)(name),
      labelId: (0, _createId.labelId)(name)
    };
  }, [name]);
  var ctx = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, staticFields), {}, {
      errorId: hasError ? staticFields.errorId : undefined,
      required: required,
      withoutLayout: withoutLayout,
      labelText: labelText,
      setLabelText: setLabelText
    });
  }, [hasError, staticFields, required, withoutLayout, labelText, setLabelText]);
  var shouldApplyCustomizeLayout = customizeLayout && typeof customizeLayout === 'function' && label && field;
  var shouldNotRenderLayout = !shouldApplyCustomizeLayout && (isHorizontal || withoutLayout);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    "data-testid": "form-group",
    className: (0, _classnames["default"])('form-group', {
      'grid grid-no-row-gap': !withoutLayout,
      required: required && !hideAsterisk
    }, className),
    ref: ref
  }, rest), /*#__PURE__*/_react["default"].createElement(_FormGroupContext.FormGroupProvider, {
    value: ctx
  }, shouldApplyCustomizeLayout && customizeLayout({
    label: label,
    field: /*#__PURE__*/_react["default"].cloneElement(field)
  }), shouldNotRenderLayout && renderGroupItems({
    children: children,
    label: label,
    field: field
  }), !shouldApplyCustomizeLayout && !shouldNotRenderLayout && /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid-item span-md-4 offset-md-4"
  }, renderGroupItems({
    children: children,
    label: label,
    field: field
  }))));
};
var FormGroupContainer = (0, _compose["default"])((0, _curryRight["default"])(_Form.connectForm)(function (_ref3, _ref4) {
  var customizeLayout = _ref3.customizeLayout,
    form = _ref3.form;
  var name = _ref4.name;
  return {
    customizeLayout: customizeLayout,
    isHorizontal: (0, _eq["default"])(_Form.HORIZONTAL)(form.alignment),
    hasError: !!name && (0, _utils.hasFieldError)((0, _prop["default"])(name)(form.errors), (0, _prop["default"])(name)(form.touched)),
    withoutLayout: !!customizeLayout
  };
}), _react.memo, _react["default"].forwardRef)(FormGroup);
var _default = exports["default"] = FormGroupContainer;